import {getTogglesStatus, getToggles, unpartitionedToggleIsOn} from 'common/storeUtils';
import store from 'go/store/reduxInit';

export default {store, getTogglesStatus, getToggles, unpartitionedToggleIsOn};
